export default "__VITE_ASSET__Bp$dYNL7__"